export const MAIN_SITE_URL = 'https://www.sherpany.com';
export const SHERPANY_SUPPORT_PHONE = '+41 44 515 89 60';
export const SHERPANY_SUPPORT_EMAIL = 'support@sherpany.com';
export const RUNTIME_CONFIG_URL = '/config/runtime-config/';

export const LOCAL_STORAGE_KEY = {
    DEMO_MEETING: 'DEMO_MEETING',
    GLOBAL_RECENT_SEARCH: 'GLOBAL_RECENT_SEARCH',
    GLOBAL_SEARCH_INSIDE_DOCS: 'GLOBAL_SEARCH_INSIDE_DOCS',
    MEETING_EDIT_MODE_TAB: 'MEETING_EDIT_MODE_TAB',
    PSPDFKIT_LAST_ANNOTATION_PRESET: 'PSPDFKIT_LAST_ANNOTATION_PRESET',
    PSPDFKIT_LAST_ANNOTATION_PRESET_PROPERTIES: 'PSPDFKIT_LAST_ANNOTATION_PRESET_PROPERTIES',
    PSPDFKIT_LAST_TOOL: 'PSPDFKIT_LAST_TOOL',
    MAIN_MENU_COLLAPSED: 'MAIN_MENU_COLLAPSED',
    WELCOME_STRIPE_VIEW: 'WELCOME_STRIPE_VIEW',
    WELCOME_STRIPE_EDIT: 'WELCOME_STRIPE_EDIT'
};
